import React, { useEffect } from 'react';
import './Toast.css';

function Toast({ message, productName, onAction, actionLabel, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="toast">
      <div className="toast-content">
        <span className="toast-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="10" cy="10" r="8"/>
            <polyline points="6.5,10 9,12.5 13.5,7.5"/>
          </svg>
        </span>
        <div className="toast-text">
          <strong>{message}</strong>
          {productName && <p>{productName}</p>}
        </div>
      </div>
      <div className="toast-actions">
        {onAction && actionLabel && (
          <button className="toast-action-btn" onClick={() => { onAction(); onClose(); }}>
            {actionLabel}
          </button>
        )}
        <button className="toast-close" onClick={onClose} aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="2" y1="2" x2="12" y2="12"/>
            <line x1="12" y1="2" x2="2" y2="12"/>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Toast;
